import { MupdfError } from "./MupdfError";

export class MupdfTryLaterError extends MupdfError {
  constructor(message) {
    super(message);
    this.name = "MupdfTryLaterError";
  }
}
